import { useRef } from 'react';
import { useKeyboardShortcut } from '../helpers/use-keyboard-shortcut';

export const useSearchFocus = () => {
  const searchReference = useRef<HTMLInputElement>(null);

  useKeyboardShortcut('meta+f', () => {
    searchReference.current?.focus();
  });

  return searchReference;
};
